export * from './dashboard.http.module';
export * from './client/bo.http.module'
export * from './abstract.service';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/http/index.ts